import React from 'react';
import axios from 'axios';
import TextField from '@material-ui/core/TextField';
import ArrowIcon from "@material-ui/icons/FontDownloadOutlined";
import AlphabetVarForSearch from '../AlphabetVarPopover/AlphabetVarForSearch'
import Autocomplete, { createFilterOptions } from '@material-ui/lab/Autocomplete';
import CircularProgress from '@material-ui/core/CircularProgress';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import './AsynchronousSearch.scss';
import SearchIcon from "@material-ui/icons/Search";
import { selectOptionsFeature, selectOptionsTV } from "./Asynchronous";
import SearchResultsLayout from './SearchResultsLayout';
import { withUserContext } from '../../../../contexts/UserContext';
import * as Constants from '../../../../constants/constants';
import CasterService from '../../../../services/service';
import ModalComponent from '../../../Common/DefaultModalLayout/Modal/Modal';
import MainViewModalComponent from '../../../Common/MainViewModalLayout/Modal/Modal';
import { talentNavList, talentFCNavList, agentNavList, productionCompanyList, crewList, representativeNavList } from '../../../../constants/NavList';
import { withRouter } from 'react-router-dom';


class AsynchronousSearch extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false,
            options: [],
            loading: false,
            isOpen: false,
            parentDropDownSelection: 1,
            childDropDownSelection: [],
            defaultSelection: [],
            searchKeyWord: '',
            totalCount : null,
            searchCancelToken: null,
            talentId: null,
            agencyId: null,
            repId: null,
            crewId: null,
            prodCompId: null,
            showTalentPopup: false,
            showAgencyPopup: false,
            showProductionPopup: false,
            showCrewPopup : false,
            showRepresentativePopup: false,
            showMainProductionPopup: false,
            showNewShowPopUp: false,
            episodeMode: "New",
            productionId: null,
            isOpen: false,
            searchString:null,
            anchorEl:null,
            isSearchPopUp:false,
        }
    }
    componentDidMount() {
    }

    functions = {
        handleShowTalentPopup: (id = null) => {
            this.setState({ showTalentPopup: true, talentId: id });
        },
        handleHideTalentPopup: () => {
            this.setState({ showTalentPopup: false });
        },
        handleShowAgencyPopup: (agencyId = null) => {
            this.setState({ showAgencyPopup: true, agencyId: agencyId });
        },
        handleHideAgencyPopup: () => {
            this.setState({ showAgencyPopup: false });
        },
        handleShowProductionPopup: (prodCompId = null) => {
            this.setState({ showProductionPopup: true, prodCompId:prodCompId });
        },
        handleShowCrewPopup: (crewId = null) => {
            this.setState({ showCrewPopup: true, crewId: crewId });
        },
        handleHideCrewPopup: () => {
            this.setState({ showCrewPopup: false });
        },
        handleHideProductionPopup: () => {
            this.setState({ showProductionPopup: false });
        },
        handleShowRepresentativePopup: (repId = null) => {
            this.setState({ showRepresentativePopup: true, repId: repId });
        },
        handleHideRepresentativePopup: () => {
            this.setState({ showRepresentativePopup: false });
        },
        handleShowMainProductionPopup: (mode, id) => {
            this.setState({ showMainProductionPopup: true, episodeMode: mode, productionId: id, disableSideNav: true });
        },
        handleHideMainProductionPopup: () => {
            this.setState({ showMainProductionPopup: false, disableSideNav: false });
        },
        handleNewShow: (mode, id) => {
            this.setState({ showNewShowPopUp: true, episodeMode: mode, production_id: id, disableSideNav: true })
        },
        hideNewShow: () => {
            this.setState({ showNewShowPopUp: false, disableSideNav: false });
        }
    }

    onChangeHandle = (searchString) => {
        if (this.state.searchCancelToken != null) {
                this.state.searchCancelToken.cancel("Operation canceled due to new request.");}
        var cancelToken = axios.CancelToken.source();
        this.setState({ searchCancelToken: cancelToken });
        let selectOptions = this.props.userContext?.active_tenant?.tenant_name !==  "Feature Casting" ? selectOptionsTV: selectOptionsFeature
        if(searchString.length > 0) {
            let searchObj = {
                'data_type':selectOptions.find(item => item.value === this.state.parentDropDownSelection).searchType,
                'search_string':searchString,
                'page_count':null,
                'page_no':null
            }
            CasterService.getDataParamsWithCancel(Constants.CasterServiceBaseUrl + '/globalSearch', searchObj , this.props.userContext?.active_tenant?.tenant_id, cancelToken) 
                .then(response => {
                    this.setState({searchString:null})
                    this.setState({ options : response.data.data, loading: false, searchKeyWord: searchString, totalCount: response.data.total_count });
                },
                    (err) => {
                        this.setState({ options: [], totalCount:0 })
                    })
        } else {
            this.setState({ options : [], loading: false, searchKeyWord: "", totalCount: 0 });
        }
    }

    filterOptions = createFilterOptions({
        stringify: (option) => option.name
    });

    handleParentSearchChange = (event) => {
        this.setState({ parentDropDownSelection: event.target.value, options: [], totalCount:0,searchKeyWord: "" })
    };

    

    handleSearchOption = (newValue) => {
        if(newValue.data_type == 'SHOWS') {
            let prodOrSeason = newValue.prod_type ==  "Episodic" ? 'ps':'p'
            let showId = prodOrSeason == 'ps' ? newValue.ps_id : newValue.production_id
            window.open(`/prod-deal-contracts/${prodOrSeason}/${showId}`) 
        } else if (newValue.data_type == 'EPISODES') {
            window.open(`/prod-deal-contracts/ps/${newValue.ps_id}/ep/${newValue.episode_id}#episode`) 
        } else if (newValue.data_type == 'TALENT'){
            this.functions.handleShowTalentPopup(parseInt(newValue.id.split('_')[1]))
        } else if (newValue.data_type == 'AGENCY'){
            this.functions.handleShowAgencyPopup(parseInt(newValue.id.split('_')[1]))
        } else if (newValue.data_type == 'REPRESENTATIVES'){
            this.functions.handleShowRepresentativePopup(parseInt(newValue.id.split('_')[1]))
        } else if (newValue.data_type == 'PRODUCTION_COMPANIES') {
            this.functions.handleShowProductionPopup(parseInt(newValue.id.split('_')[1]))
        } else if(newValue.data_type == 'CREW') {
            this.functions.handleShowCrewPopup(parseInt(newValue.id.split('_')[1]))
        } else if(newValue.data_type == 'ROLES') {
            let prodOrSeason = newValue.prod_type ==  "Episodic" ? 'ps':'p'
            let showId = prodOrSeason == 'ps' ? newValue.ps_id : newValue.production_id
            if(newValue.episode_id !== null) {
                window.open(`/prod-deal-contracts/${prodOrSeason}/${showId}/ep/${newValue.episode_id}#episode`)
            } else {
                window.open(`/prod-deal-contracts/${prodOrSeason}/${showId}`)
            }
        } else if(newValue.data_type == 'PERFORMERS') {
            let prodOrSeason = newValue.prod_type ==  "Episodic" ? 'ps':'p'
            let showId = prodOrSeason == 'ps' ? newValue.ps_id : newValue.production_id
            if(newValue.episode_id !== null) {
                window.open(`/prod-deal-contracts/${prodOrSeason}/${showId}/ep/${newValue.episode_id}/perf/${newValue.id.split('_')[1]}`)
            } else {
                window.open(`/prod-deal-contracts/${prodOrSeason}/${showId}/perf/${newValue.id.split('_')[1]}`)
            } 
        }
    }

    render() {
        let selectOptions = this.props.userContext?.active_tenant?.tenant_name !==  "Feature Casting" ? selectOptionsTV: selectOptionsFeature
        return (
            <>
                <div class='row PLSearch'>
                    <div class='col-3' id='txtAllSelect'>
                        <Select
                            variant="outlined"
                            displayEmpty className='selectStyle'
                            defaultValue={this.state.parentDropDownSelection}
                            onChange={this.handleParentSearchChange}
                            MenuProps={{
                                getContentAnchorEl: null,
                                anchorOrigin: {
                                    vertical: "bottom",
                                    horizontal: "left"
                                }
                            }}
                        >
                            {
                                selectOptions?.map((item, index) => {
                                    return <MenuItem key={index} value={item.value}>{item.label}</MenuItem>
                                })
                            }
                        </Select>

                    </div>
                    <div class='col-9 ptPt4' id='txtSearch'>
                        <AlphabetVarForSearch
                            isOpen={this.state.isOpen}
                            anchorEl={this.state.anchorEl}
                            onClose={() => { this.setState({ isOpen: false, anchorEl: null }) }}
                            searchString={this.state.searchString}
                            onChangeString={(value) => {this.setState({ searchString: value})}}
                            onClickSearch={() => {
                                this.setState({ isOpen: false, anchorEl: null, loading: true, isSearchPopUp:true, }, () => {
                                    this.onChangeHandle(this.state.searchString) })
                            }}>
                        </AlphabetVarForSearch>
                        <Autocomplete 
                            value={this.state.defaultSelection}
                            id="asynchronous-demo" className='autoCompleteStyle'
                            open={this.state.open || this.state.isSearchPopUp}
                            onOpen={() => {
                                this.setState({ open: true })
                            }}
                            onClose={() => {
                                this.setState({ open: false, options: [], totalCount:0 ,isSearchPopUp :false}) 
                            }}
                            renderOption={(props, option) => (
                                <>
                                    <li {...props}>
                                        <SearchResultsLayout searchResult={props}></SearchResultsLayout>
                                    </li>
                                </>
                            )}
                            onChange={(event, newValue) => {
                                if (newValue && newValue.result_type != 'recordCount') {
                                   this.handleSearchOption(newValue)
                                } else if (newValue && newValue.result_type == 'recordCount') {
                                    this.setState({ defaultSelection: [] })
                                    this.props.history.push('/userSearch/' + this.state.parentDropDownSelection + '/' + this.state.searchKeyWord)
                                } else {
                                    this.setState({ defaultSelection: [] })
                                }
                                this.setState({options : [], totalCount:0,searchString:null, isSearchPopUp:false})
                            }}

                            filterOptions={(options, params) => {
                                options = this.filterOptions(options, params)
                                if (this.state.totalCount > 0) {
                                    let type = this.state.totalCount === 1 ? 'result' : 'results'
                                    options.unshift({
                                        sub_group : `${this.state.totalCount} search ${type}`
                                    })
                                    if (this.state.totalCount > 1) {
                                        options.push({
                                            name: `See all ${this.state.totalCount} results`,
                                            result_type: 'recordCount'
                                        });
                                    }
                                } else {
                                    options=[]
                                }
                                return options;
                            }}
                            getOptionLabel={(option) => option.name}
                            options={this.state.options}
                            loading={this.state.loading}
                            renderTags={() => null}
                            noOptionsText="No labels"
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    placeholder="Search..."
                                    variant="outlined"
                                    onChange={ev => {
                                        if (ev.target.value !== "" || ev.target.value !== null) {
                                            this.setState({ loading: true, searchString: ev.target.value,isSearchPopUp:false,options: [], totalCount:0 }, () => { this.onChangeHandle(ev.target.value) })
                                        } else { this.setState({ loading: false, options: [], totalCount:0,isSearchPopUp:false, }) }
                                    }}
                                    InputProps={{
                                        ...params.InputProps,
                                        endAdornment: (
                                            <React.Fragment>
                                                {this.state.loading ? <CircularProgress color="inherit" size={20} /> : null}
                                                <ArrowIcon onClick={(event) => this.setState({isOpen:true, anchorEl: event.currentTarget, isSearchPopUp:false,})} /><SearchIcon className='MRN3' />
                                                {params.InputProps.endAdornment}
                                            </React.Fragment>
                                        ),
                                    }}
                                />
                            )}
                        />
                    </div>
                </div>
                {
                    this.state.showTalentPopup ?
                        <ModalComponent
                            navFuns={this.functions}
                            talentId={this.state.talentId}
                            open={this.state.showTalentPopup}
                            handleClose={this.functions.handleHideTalentPopup}
                            tabList={this.props.userContext?.active_tenant?.tenant_name !==  "Feature Casting" ? 
                                talentNavList : 
                                talentFCNavList
                            }
                            bodyText={"Search for Talent to view their Data, or create a new Talent"}
                            searchPlaceholder={"Search Talent by name or SSN"}
                            headerText={"Talent"} 
                            addButtonText={"New Talent"} objectType={'TALENT'}
                            dataUrl='talentDetails' /> : null
                }
                {
                    this.state.showAgencyPopup ?
                        <ModalComponent
                            navFuns={this.functions}
                            open={this.state.showAgencyPopup}
                            handleClose={this.functions.handleHideAgencyPopup}
                            tabList={agentNavList}
                            bodyText={"Search for an Agency to view its Data"}
                            searchPlaceholder={"Search Agencies by name, type or ID"}
                            addButtonText={"New Agency"}
                            agencyId={this.state.agencyId} objectType={'AGENCY'}
                            headerText={"Agency"} dataUrl='agencyDetails' /> : null
                }
                {
                    this.state.showProductionPopup ?
                        <ModalComponent
                            navFuns={this.functions}
                            open={this.state.showProductionPopup}
                            handleClose={this.functions.handleHideProductionPopup}
                            tabList={productionCompanyList}
                            prodCompId={this.state.prodCompId}
                            bodyText={"Search for Pr.oduction Companies to view its Data"}
                            searchPlaceholder={"Search production companies by name"}
                            addButtonText={"New Production Co."} objectType={'PRODUCTION_COMPANY'}
                            headerText={"Production Companies"} dataUrl='productionCompany' /> : null
                }
                {
                    this.state.showCrewPopup ?
                        <ModalComponent
                            navFuns={this.functions}
                            open={this.state.showCrewPopup}
                            crewId={this.state.crewId}
                            handleClose={this.functions.handleHideCrewPopup}
                            tabList={crewList}
                            bodyText={"Search for a Crew Member to view their Data"}
                            searchPlaceholder={"Search by Crew Member name"}
                            addButtonText={"New Crew Member"} objectType={'CREW'}
                            headerText={"Crew"} dataUrl='crewDetails' /> : null
                }
                {
                    this.state.showRepresentativePopup ?
                        <ModalComponent
                            navFuns={this.functions}
                            open={this.state.showRepresentativePopup}
                            handleClose={this.functions.handleHideRepresentativePopup}
                            tabList={representativeNavList}
                            bodyText={"Search for a Representative to view its Data"}
                            searchPlaceholder={"Search by Representative name"}
                            addButtonText={"New Representative"}
                            repId={this.state.repId} objectType={'REPRESENTATIVE'}
                            headerText={"Representatives"} dataUrl='representativeDetails' /> : null
                }
                {
                    this.state.showMainProductionPopup &&
                    <MainViewModalComponent
                        open={this.state.showMainProductionPopup}
                        handleClose={this.functions.handleHideMainProductionPopup}
                        headerText={this.state.episodeMode === "New" ? "Production Details" : "Production Details"}
                        mode={this.state.episodeMode}
                        id={this.state.productionId}
                        modalName={"Main Production"} />
                }
                {
                    this.state.showNewShowPopUp &&
                        <MainViewModalComponent
                            open={this.state.showNewShowPopUp}
                            handleClose={this.functions.hideNewShow}
                            headerText={this.state.episodeMode === "New" ? "Show" : "Show Details"}
                            modalName={"New Show"}
                            mode={this.state.episodeMode}
                            id={this.state.production_id}
                            production_id={this.state.production_id}
                        />
                }
            </>
        );
    }

}
export default withRouter(withUserContext(AsynchronousSearch));